var EProductStatus = /*#__PURE__*/ function(EProductStatus) {
    EProductStatus["Active"] = "active";
    EProductStatus["Disabled"] = "disabled";
    return EProductStatus;
}(EProductStatus || {});
var EProductType = /*#__PURE__*/ function(EProductType) {
    EProductType["WordPressPlugin"] = "wordPressPlugin";
    EProductType["SaasProduct"] = "saasProduct";
    EProductType["GeneralService"] = "generalService";
    EProductType["CookieExpertService"] = "cookieExpertService";
    return EProductType;
}(EProductType || {});
export { EProductStatus, EProductType };
